<template>
  <div>
    <v-form
      v-model="valid"
      ref="customerForm"
      lazy-validation
      @keyup.native.enter="complete"
    >
      <v-container>
        <v-subheader>{{ $t("steps.customer.basic") }}</v-subheader>
        <v-switch
          v-model="isCompany"
          prepend-icon="mdi-account-tie"
          :input-value="customer('is_company')"
          :label="$t('steps.customer.isCompany')"
        >
        </v-switch>
        <v-row>
          <v-col v-if="isCompany" cols="12" xs="12" md="6" lg="4">
            <v-text-field
              :value="customer('company_name')"
              @change="setCustomerParam('company_name', $event)"
              :rules="companyNameRules"
              :label="$t('steps.customer.company')"
            >
            </v-text-field>
          </v-col>
          <v-col v-if="isCompany" cols="12" xs="12" md="6" lg="4">
            <v-text-field
              :value="customer('nip')"
              @change="setCustomerParam('nip', $event)"
              :rules="nipRules"
              v-mask="'###-###-##-##'"
              :label="$t('steps.customer.nip')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="!isCompany" cols="12" xs="12" md="6" lg="4">
            <v-text-field
              :value="customer('first_name')"
              @change="setCustomerParam('first_name', $event)"
              :rules="nameRules"
              :label="$t('steps.customer.firstname')"
            >
            </v-text-field>
          </v-col>
          <v-col v-if="!isCompany" cols="12" xs="12" md="6" lg="4">
            <v-text-field
              :value="customer('last_name')"
              @change="setCustomerParam('last_name', $event)"
              :rules="nameRules"
              :label="$t('steps.customer.lastname')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-subheader>{{ $t("steps.customer.communication") }}</v-subheader>
        <v-row>
          <v-col cols="12" xs="12" md="6" lg="4">
            <v-text-field
              :value="customer('email')"
              @change="setCustomerParam('email', $event)"
              :rules="emailRules"
              :label="$t('steps.customer.email')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" md="6" lg="4">
            <v-text-field
              :value="customer('phone')"
              @change="setCustomerParam('phone', $event)"
              :label="$t('steps.customer.phone')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-subheader>{{ $t("steps.customer.address") }}</v-subheader>
        <v-row>
          <v-col cols="12" xs="12" md="8" lg="6">
            <v-text-field
              :value="customer('street')"
              @change="setCustomerParam('street', $event)"
              :label="$t('steps.customer.street')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="6" md="3" lg="2">
            <v-text-field
              :value="customer('house')"
              @change="setCustomerParam('house', $event)"
              :label="$t('steps.customer.house')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="6" md="3" lg="2">
            <v-text-field
              :value="customer('apartment')"
              @change="setCustomerParam('apartment', $event)"
              :label="$t('steps.customer.apartment')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="6" md="4" lg="3">
            <v-text-field
              :value="customer('postal')"
              @change="setCustomerParam('postal', $event)"
              return-masked-value
              v-mask="'##-###'"
              :rules="postalRules"
              :label="$t('steps.customer.postal')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" md="8" lg="6">
            <v-text-field
              :value="customer('city')"
              @change="setCustomerParam('city', $event)"
              :label="$t('steps.customer.city')"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <Partner v-if="$auth.check('admin')"></Partner>
    <div v-if="!isManualOrder">
      <v-btn color="primary" :disabled="!valid" @click="complete">{{
        $t("base.next")
      }}</v-btn>
      <v-btn text @click="$emit('abort')">{{ $t("base.back") }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import nip from "@/helpers/nip-validator";
import Partner from "@/components/orders/Partner";

export default {
  components: {
    Partner,
  },

  props: {
    isManualOrder: { type: Boolean, value: false },
  },
  computed: {
    customer() {
      return (param) => this.$store.getters.customer(param);
    },
  },
  directives: { mask },
  data() {
    return {
      isCompany: this.$store.getters.customer("is_company") || false,
      valid: false,
      companyNameRules: [
        (v) =>
          !v ||
          v.length <= 150 ||
          this.$t("validation.toolong", { length: 150 }),
      ],
      nameRules: [
        (v) =>
          !v || v.length <= 50 || this.$t("validation.toolong", { length: 50 }),
      ],
      emailRules: [
        (v) => !!v || this.$t("validation.required"),
        (v) => /[^@]+@[^\.]+\..+/.test(v) || this.$t("validation.email"),
      ],
      postalRules: [
        (v) => !v || /^\d{2}\-\d{3}$/.test(v) || this.$t("validation.postal"),
      ],
      nipRules: [(v) => !v || nip(v) || this.$t("validation.nip")],
    };
  },
  methods: {
    setCustomerParam(param, value) {
      this.$store.commit("setCustomerProperty", { param, value });
    },
    complete() {
      if (this.$refs.customerForm.validate()) {
        this.$emit("complete");
      }
    },
  },
  watch: {
    isCompany(val) {
      this.setCustomerParam("is_company", val);
    },
  },
};
</script>

<style scoped>
</style>
